import React from 'react';
import { useSpring, animated } from 'react-spring';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import './styles.css';

const propTypes = {
  speedValues: PropTypes.oneOfType([PropTypes.object]),
  scrollPos: PropTypes.number,
};

const defaultProps = {
  speedValues: {},
  scrollPos: 0,
};

const Florest = ({ speedValues, scrollPos }) => {
  const { speedSlow } = useSpring({
    from: { speedSlow: [scrollPos, 0, 0] },
    to: { speedSlow: [speedValues.slow, 0, 0] },
  });
  const { speedNormal } = useSpring({
    from: { speedNormal: [scrollPos, 0, 0] },
    to: { speedNormal: [speedValues.normal, 0, 0] },
  });
  const { speedFast } = useSpring({
    from: { speedFast: [scrollPos, 0, 0] },
    to: { speedFast: [speedValues.fast, 0, 0] },
  });
  const { speedFaster } = useSpring({
    from: { speedFaster: [scrollPos, 0, 0] },
    to: { speedFaster: [speedValues.faster, 0, 0] },
  });
  const { speedSuperFaster } = useSpring({
    from: { speedSuperFaster: [scrollPos, 0, 0] },
    to: { speedSuperFaster: [speedValues.superFaster, 0, 0] },
  });

  return (
    <div className="scenario-1">
      <animated.div
        className="layer-1"
        style={{
          transform: speedSlow.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className="sky" />
        <div className="background" />
        <div className="star-1" />
        <div className="star-2" />
        <div className="star-3" />
        <div className="star-4" />
        <div className="star-5" />
        <div className="star-6" />
        <div className="star-7" />
        <div className="star-8" />
        <div className="star-9" />
        <div className="star-10" />
        <div className="star-11" />
        <div className="star-12" />
        <div className="moon" />
        <div className="backmountain-1" />
        <div className="backmountain-2" />
        <div className="backmountain-3" />
        <div className="backmountain-4" />
      </animated.div>
      <animated.div
        className="layer-2"
        style={{
          transform: speedNormal.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className="mountain-1" />
        <div className="mountain-2" />
        <div className="mountain-3" />
        <div className="mountain-4" />
        <div className="mountain-5" />
        <div className="mountain-6" />
        <div className="mountain-7" />
      </animated.div>
      <animated.div
        className="layer-3"
        style={{
          transform: speedFast.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className="tree-1" />
        <div className="tree-2" />
        <div className="tree-3" />
        <div className="tree-4" />
      </animated.div>
      <animated.div
        className="layer-4"
        style={{
          transform: speedFaster.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className={`${isMobile ? 'arrow-sign' : 'scroll-sign'}`} />
        <div className="soft-skills-sign" />
      </animated.div>
      <animated.div
        className="layer-5"
        style={{
          transform: speedSuperFaster.to(
            (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
          ),
        }}
      >
        <div className="fog-1" />
        <div className="fog-2" />
        <div className="fog-3" />
        <div className="fog-4" />
        <div className="fog-5" />
      </animated.div>
    </div>
  );
};

export default Florest;

Florest.propTypes = propTypes;
Florest.defaultProps = defaultProps;
